import { render } from "./vueForm.vue?vue&type=template&id=37dab2a1&lang=pug"
import script from "./vueForm.vue?vue&type=script&lang=js"
export * from "./vueForm.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vueForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37dab2a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37dab2a1', __exports__)) {
    api.reload('37dab2a1', __exports__)
  }
  
  module.hot.accept("./vueForm.vue?vue&type=template&id=37dab2a1&lang=pug", () => {
    api.rerender('37dab2a1', render)
  })

}


export default __exports__